var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83.46,
    height: 78.91,
    viewBox: "0 0 83.46 78.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.91,12.94a12.9,12.9,0,0,0-3.78-9.16h0a13,13,0,0,0-18.32,0L3.4,57.2A3.28,3.28,0,0,0,2.48,59L0,75.17a3.24,3.24,0,0,0,3.21,3.74,2.77,2.77,0,0,0,.49,0L19.9,76.42a3.2,3.2,0,0,0,1.81-.91L75.13,22.09A12.89,12.89,0,0,0,78.91,12.94ZM70.53,17.5,17.87,70.16,7.12,71.78,8.75,61,61.41,8.38a6.47,6.47,0,0,1,9.12,0h0a6.47,6.47,0,0,1,0,9.12ZM83.46,75.08a3.25,3.25,0,0,1-3.25,3.25H40.67a3.25,3.25,0,0,1,0-6.5H80.21A3.24,3.24,0,0,1,83.46,75.08Z",
    fill: "#D163AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.5c2a756531420c1db6ddb37ff7bacf46.svg";
export { ForwardRef as ReactComponent };